import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { productoActions } from "../../../_actions";
import vendedorService from "../../../_services/cart/vendedor.service";
import { nombreVendedor } from "../../../_helpers";

/**
 * Modal de "Consulta": las opciones de WhatsApp para escribirle al vendedor de un producto.
 *
 * Arriba va el numero principal de la publicacion y abajo los contactos que el vendedor
 * cargo en su perfil (la gente que trabaja con el). Los contactos NO viajan con el
 * producto: se piden aca al abrirse, para no arrastrar una coleccion por fila en el
 * listado. Mientras llegan igual se puede escribir al principal.
 */
class ModalWhatsappVendedor extends React.Component {

    state = {
        contactos: [],
        cargando: false,
        vendedorCargado: undefined,
    };

    componentDidMount() {
        this.cargarContactos();
    }

    componentDidUpdate() {
        this.cargarContactos();
    }

    cargarContactos = () => {
        const { producto } = this.props;
        const vendedorId = producto?.vendedor?.id;

        // Se recarga solo si cambio el vendedor: en el listador el mismo modal se reusa
        // para productos distintos, y sin esto entraria en loop por el componentDidUpdate.
        if (!vendedorId || this.state.cargando || this.state.vendedorCargado === vendedorId) {
            return;
        }

        this.setState({ cargando: true, vendedorCargado: vendedorId, contactos: [] });

        vendedorService.traerContactos(vendedorId, (contactos) => {
            this.setState({ contactos: contactos ?? [], cargando: false });
        });
    };

    abrirWhatsapp = (telefono) => {
        const { producto, handleClose } = this.props;

        window.open(productoActions.crearLinkWhatsapp(producto, telefono), "_blank", "noopener,noreferrer");

        handleClose();
    };

    renderOpcion = (key, nombre, telefono, esPrincipal) => (
        <button
            key={key}
            type="button"
            className="button w-100 modal-wsp__opcion"
            data-type={esPrincipal ? "message" : "complementary"}
            onClick={() => this.abrirWhatsapp(telefono)}
        >
            <div className="btn--logo">
                <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg" />
            </div>
            <span className="modal-wsp__opcion-nombre">{nombre}</span>
        </button>
    );

    render() {
        const { show, handleClose, producto } = this.props;
        const { contactos, cargando } = this.state;

        const telefonoPrincipal = producto?.vendedor?.numeroCelular;
        const nombrePrincipal = nombreVendedor(producto?.vendedor) || "Vendedor";

        return (
            <Modal show={show} onHide={() => handleClose()} centered>
                <Modal.Header closeButton>
                    <Modal.Title>¿Con quién querés hablar?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="small">
                        Elegí un contacto y te abrimos WhatsApp con el link de la publicación.
                    </p>

                    <div className="modal-wsp__opciones">
                        {!!telefonoPrincipal &&
                            this.renderOpcion("principal", nombrePrincipal, telefonoPrincipal, true)}

                        {contactos.map((contacto) =>
                            this.renderOpcion(contacto.id, contacto.nombre, contacto.whatsapp, false)
                        )}
                    </div>

                    {cargando && (
                        <p className="small mt-2">
                            <FontAwesomeIcon icon="fa-solid fa-spinner" spin /> Buscando más contactos...
                        </p>
                    )}

                    {!cargando && !telefonoPrincipal && contactos.length === 0 && (
                        <p className="small mt-2">Este vendedor no tiene un WhatsApp cargado.</p>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export { ModalWhatsappVendedor };
